import { z } from 'zod'

export const CodeEntry = z.object({
    id: z.number(),

    listId: z.number(),

    listIdentifier: z.string(),

    value1: z.string().nullable().default(null),

    value2: z.string().nullable().default(null),

    value3: z.string().nullable().default(null),

    value4: z.string().nullable().default(null)
})
